<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <div class="control has-icons-left">
                    <input v-model="search" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>            
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}}
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items">
                    <td>{{index + 1}}</td>
                    <td>{{item.teacher}}</td>
                    <td :class="{'has-text-success': item.fee > 0}">${{item.fee}}</td>
                    <td>{{item.status}}</td>
                    <td>{{item.payout_date}}</td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import AffiliateRepo from '../../repos/AffiliateRepo'
import lodash from 'lodash'

export default {
  name: 'affiliate-table',
  props: {
	items: { required: true },
    page: { required: true },
    total: { required: false, default: 0 },
    actions: {required: false, default: false},
    pivot: {required: false, default: false}
  },
  components: {},
  data() {
        return {
            search: '',
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: ''
                },
                {
                    name: 'Teacher',
                    key: 'teacher'
                },
                {
                    name: 'Earned',
                    key: 'fee'
                },
                {
                    name: 'Status',
                    key: 'status'
                },
                {
                    name: 'Payout date',
                    key: 'payout_date'
                }
            ],
            reverse: true,
            repo: new AffiliateRepo(this.$auth),
        }
  },
  created(){        
  },
  methods: {
    sortBy(column) {    
    
        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },   
    onPageChanged(page){
        this.$emit("pageChanged", page);
    },
  },
  watch: {
      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800) 
  },
  computed: {
  }  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/stats/Table.vue